import { render, staticRenderFns } from "./platform_branches.vue?vue&type=template&id=619bb1d6&"
import script from "./platform_branches.vue?vue&type=script&lang=js&"
export * from "./platform_branches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports